// extracted by mini-css-extract-plugin
export var chip = "_52-9";
export var chipLabel = "_52-a";
export var close = "_52-7";
export var closeIcon = "_52-8";
export var error = "_52-6";
export var infoTooltip = "_52-2";
export var innerContainer = "_52-1";
export var input = "_52-b";
export var medium = "_52-5";
export var outerContainer = "_52-0";
export var small = "_52-4";
export var xSmall = "_52-3";